<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 18:12:10
 * @Description: 账号激活 激活方式
-->
<template>
	<div class="j_h_type">
		<a-form-model :model="form" ref="form" :wrapper-col="wrapperCol" :rules="rules">
			<a-form-model-item>
				<a-select v-model="form.noticeClassify" @change="selectChange">
					<a-select-option value="1" v-if="basicSetInfo.jhfs.includes('1')">{{ $t("base.email.label") }}</a-select-option>
					<a-select-option value="2" v-if="basicSetInfo.jhfs.includes('2')">{{ $t("base.mobile.label") }}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item prop="account" class="j_h_flex">
				<a-select defaultValue="1" v-if="form.noticeClassify == 2">
					<a-select-option value="1">{{ $t("base.mobile.china") }}+86</a-select-option>
				</a-select>
				<a-input
					v-model="form.account"
					:placeholder="`${$t('base.input')}${form.noticeClassify == 1 ? `${$t('base.email.label')}` : `${$t('base.mobile.label')}`}`"
				></a-input>
			</a-form-model-item>
			<a-form-model-item prop="captcha" class="j_h_flex">
				<a-input class="j_h_flex_l" v-model="form.captcha" :placeholder="$t('base.captcha.placeholder')" />
				<div class="codeBox">
					<a-button v-if="count == 60" type="primary" @click="handleCode">{{ $t("base.btn.get_code") }}</a-button>
					<a-button type="primary" disabled v-else>{{ count }}s</a-button>
				</div>
			</a-form-model-item>
		</a-form-model>

		<div class="next">
			<a-button style="width: 440px" type="primary" @click="handleNext">{{ $t("base.btn.next_step") }}</a-button>
		</div>
	</div>
</template>

<script>
import { commonAPI } from "@/apis";

export default {
	props: {
		basicSetInfo: { type: Object, default: () => {} },
	},
	data() {
		let accountValidator = (rule, value, callback) => {
			let type = this.form.noticeClassify;
			if (value == "") {
				callback(new Error(`${this.$t("base.input")}${type == 1 ? `${this.$t("base.email.label")}` : `${this.$t("base.mobile.label")}`}`));
			}
			const reg1 = new RegExp(/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/); // 邮箱
			const reg2 = new RegExp(/^1[3456789]\d{9}$/); // 手机号
			if (type == 1 && !reg1.test(value)) {
				callback(new Error(this.$t("base.email.error_tip")));
			}
			if (type == 2 && !reg2.test(value)) {
				callback(new Error(this.$t("base.mobile.error_tip")));
			}
			callback();
		};

		return {
			wrapperCol: { span: 18, offset: 3 },
			form: { noticeClassify: "1", account: "", captcha: "" },
			rules: {
				account: [{ validator: accountValidator }],
				captcha: [{ required: true, message: this.$t("base.captcha.placeholder") }],
			},
			count: 60,
		};
	},
	methods: {
		// 切换方式
		selectChange() {
			this.$refs.form.clearValidate();
		},
		// 获取验证码
		handleCode() {
			this.$refs.form.validateField("account", (message) => {
				if (!message) {
					this.handleVerify();
				} else {
					return false;
				}
			});
		},
		// 验证手机邮箱
		async handleVerify() {
			let obj = JSON.parse(localStorage.getItem("ACTIVATE_INFO"));
			let params = {
				noticeClassify: this.form.noticeClassify,
				account: this.form.account,
				userName: obj.username,
			};
			const { code } = await commonAPI.postAction("/send/msg/verifyUserInfo", params);
			if (code == 0) {
				this.handleCodeApi();
			} else {
				this.$message.warning(`${this.form.account}${this.$t("login.activate.irrelevant")}`);
			}
		},
		// 获取验证码
		async handleCodeApi() {
			let params = {
				noticeClassify: this.form.noticeClassify,
				account: this.form.account,
				businessClassify: "account_active",
			};
			const { code, message } = await commonAPI.getAction("/send/msg/sendCaptcha", params);
			if (code == 0) {
				this.$message.success(message);
				// 开启倒计时
				this.count--;
				const timer = setInterval(() => {
					if (this.count > 0 && this.count <= 60) {
						this.count--;
					} else {
						this.count = 60;
						clearInterval(timer);
					}
				}, 1000);
			} else {
				this.$message.error(message);
			}
		},
		// 下一步
		handleNext() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.handleNextApi();
				} else {
					return false;
				}
			});
		},
		async handleNextApi() {
			let activateInfo = {};
			try {
				activateInfo = JSON.parse(localStorage.getItem("ACTIVATE_INFO") || "{}");
			} catch (e) {
				activateInfo = {};
			}
			let params = {
				noticeClassify: this.form.noticeClassify,
				captcha: this.form.captcha,
				businessClassify: "account_active",
				account: this.form.account,
				userAcount: activateInfo.username,
			};
			const { code, message, data } = await commonAPI.getAction("/user/active/checkCaptcha", params);
			if (code == 0) {
				this.$message.success(message);
				this.$emit("next", 2, { ...params, resetToken: data });
			} else {
				this.$message.error(message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.j_h_type::v-deep {
	.j_h_flex .ant-form-item-children {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		.ant-select {
			width: 140px;
		}
		.ant-select + .ant-input,
		.j_h_flex_l {
			width: calc(100% - 150px);
		}
		.codeBox {
			width: 140px;
			& > * {
				width: 100%;
			}
		}
	}
	.next {
		padding-top: 20px;
		text-align: center;
	}
}
</style>
